import { __rest, __assign } from '../../../../_virtual/_tslib.js';
import React from 'react';
import { useWindowSize } from '@citygross/utils';
import { useTheme } from 'styled-components';
import { SearchBarContainer, SearchForm, SearchLeftIcon, SearchInput, SearchRightLabel, MobileSearchIconContainer, SearchResultContainer, MobileSearchFormContainer } from './SearchBar.styles.js';

var SearchBar = function SearchBar(_a) {
  var _b, _c, _d;

  var flexGrow = _a.flexGrow,
      isValid = _a.isValid,
      _e = _a.inputSize,
      inputSize = _e === void 0 ? 'medium' : _e,
      activeBorderColor = _a.activeBorderColor,
      cancelLabel = _a.cancelLabel,
      inputIcon = _a.inputIcon,
      icon = _a.icon,
      value = _a.value,
      resultBoxTopPosition = _a.resultBoxTopPosition,
      children = _a.children,
      inputRef = _a.inputRef,
      isOpen = _a.isOpen,
      searchOnSubmit = _a.searchOnSubmit,
      searchInputMobileRef = _a.searchInputMobileRef,
      mobileTopPosition = _a.mobileTopPosition,
      props = __rest(_a, ["flexGrow", "isValid", "inputSize", "activeBorderColor", "cancelLabel", "inputIcon", "icon", "value", "resultBoxTopPosition", "children", "inputRef", "isOpen", "searchOnSubmit", "searchInputMobileRef", "mobileTopPosition"]);

  var width = useWindowSize().width;
  var theme = useTheme();
  var resultVariants = {
    closed: {
      height: '0',
      transition: {
        duration: 0,
        ease: 'linear'
      }
    },
    open: {
      height: theme.constants && width < ((_b = theme.constants) === null || _b === void 0 ? void 0 : _b.headerBreakpoint) ? '100%' : 'auto',
      transition: {
        duration: theme.constants && width < ((_c = theme.constants) === null || _c === void 0 ? void 0 : _c.headerBreakpoint) ? 0 : 0.2,
        delay: theme.constants && width < ((_d = theme.constants) === null || _d === void 0 ? void 0 : _d.headerBreakpoint) ? 0 : 0.1,
        ease: 'linear'
      }
    }
  };
  var iconVariants = {
    closed: {
      opacity: 0,
      display: 'none',
      transition: {
        duration: 0,
        delay: 0,
        ease: 'linear'
      }
    },
    open: {
      opacity: 1,
      display: 'flex',
      transition: {
        duration: 0.1,
        delay: 0.1,
        ease: 'linear'
      }
    }
  };
  return React.createElement(React.Fragment, null, React.createElement(SearchBarContainer, {
    activeBorderColor: activeBorderColor,
    inputSize: inputSize,
    flexGrow: flexGrow,
    isOpen: isOpen
  }, React.createElement(SearchForm, {
    hideInMobile: true,
    isOpen: isOpen,
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      searchOnSubmit && searchOnSubmit();
    }
  }, React.createElement(SearchLeftIcon, null, inputIcon), React.createElement(SearchInput, __assign({
    flexGrow: flexGrow,
    isValid: isValid,
    inputSize: inputSize,
    activeBorderColor: activeBorderColor,
    ref: inputRef
  }, props, {
    value: value,
    autoComplete: "off",
    "data-lpignore": "true",
    "data-form-type": "other"
  })), cancelLabel ? React.createElement(SearchRightLabel, {
    onClick: function onClick(e) {
      e.stopPropagation();
    },
    variants: iconVariants,
    animate: isOpen ? 'open' : 'closed',
    initial: 'closed'
  }, cancelLabel) : null), React.createElement(MobileSearchIconContainer, null, React.createElement(SearchLeftIcon, null, icon)), React.createElement(SearchResultContainer, {
    topPosition: resultBoxTopPosition,
    isOpen: isOpen,
    variants: resultVariants,
    animate: isOpen ? 'open' : 'closed',
    initial: 'closed',
    mobileTopPosition: mobileTopPosition
  }, React.createElement(MobileSearchFormContainer, null, React.createElement(SearchForm, {
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      searchOnSubmit && searchOnSubmit();
    }
  }, React.createElement(SearchLeftIcon, null, inputIcon), React.createElement(SearchInput, __assign({
    flexGrow: flexGrow,
    isValid: isValid,
    activeBorderColor: activeBorderColor,
    ref: searchInputMobileRef
  }, props, {
    value: value,
    autoComplete: "off",
    "data-lpignore": "true",
    "data-form-type": "other",
    tabIndex: isOpen ? 0 : -1
  })), cancelLabel ? React.createElement(SearchRightLabel, {
    onClick: function onClick(e) {
      e.stopPropagation();
    }
  }, cancelLabel) : null)), children)));
};

export { SearchBar };